export const REPORT = {
  ISSUE_REPORT: {
    TH: 'รายงานปัญหา',
    EN: 'Issue Report',
  },
  FACILITY_MAINTENANCE: {
    TH: 'การบำรุงรักษาสิ่งอำนวยความสะดวก',
    EN: 'Facility maintenance',
  },
  PROVIDE_ISSUE: {
    TH: 'ระบุกรณีปัญหาที่ชัดเจนเมื่อคุณรายงาน',
    EN: 'Provide clear issue cases when you report.',
  },
  REPORT: {
    TH: 'รายงาน',
    EN: 'Report',
  },
  SUCCESS: {
    TH: 'สำเร็จ!',
    EN: 'Success!',
  },
  SUCCESS_DETAIL: {
    TH: 'ปัญหาถูกส่งไปยังผู้รับผิดชอบแล้ว',
    EN: 'Issue has been sent to responsible person.',
  },
  ERROR: {
    TH: 'เกิดข้อผิดพลาด!',
    EN: 'Error!'
  },
  ERROR_DETAIL: {
    TH: 'เกิดปัญหาในการส่งปัญหาของคุณ โปรดลองอีกครั้ง',
    EN: 'There was a problem submitting your issue, Please try again.',
  },
  EDIT: {
    TH: 'แก้ไข',
    EN: 'Edit',
  },
  DONE: {
    TH: 'เสร็จสิ้น',
    EN: 'Done',
  },
  COMPLETED_STATUS: {
    TH: 'ดำเนินการแก้ไขแล้ว',
    EN: 'Completed',
  },
  ON_GOING_STATUS: {
    TH: 'กำลังดำเนินการ',
    EN: 'On-Going',
  },
  WAITING_STATUS: {
    TH: 'รอดำเนินการ',
    EN: 'Waiting',
  },
  ISSUE: {
    TH: 'ปัญหา',
    EN: 'Issue',
  },
  NOT_FOUND_ISSUE: {
    TH: 'ไม่มีรายงานปัญหา',
    EN: 'No Issue Report',
  },
  OTHER: {
    TH: 'อื่น ๆ',
    EN: 'Other',
  },

  FACILITIES: {
    NAME: {
      TH: 'ชื่อ',
      EN: 'Name',
    },
    STATUS: {
      TH: 'สถานะ',
      EN: 'Status',
    },
    STATUS_NAME: {
      ACTIVE: {
        TH: 'ใช้งาน',
        EN: 'Active',
      },
      INACTIVE: {
        TH: 'ไม่ใช้งาน',
        EN: 'Inactive',
      },
      CLOSED: {
        TH: 'ปิด',
        EN: 'Closed',
      },
    }
  }

}

export const FACILITIES_STATUS = { ACTIVE: 0, INACTIVE: 1, CLOSED: 2 }
export const FACILITIES_TYPE = { 0:'ACTIVE', 1:'INACTIVE', 2:'CLOSED' }
